export const ADMIN = {
  page: 'admin-page',
  tabOverview: 'admin-tab-overview',
  tabAnalytics: 'admin-tab-analytics',
  tabUsers: 'admin-tab-users',
  tabReports: 'admin-tab-reports',
  analyticsTab: 'admin-analytics-tab',
  topUserRow: 'admin-top-user-row',
  searchInput: 'admin-search-input',
  userRow: 'admin-user-row',
  promoteUserButton: 'admin-promote-user-button',
  demoteUserButton: 'admin-demote-user-button',
  confirmRoleButton: 'admin-confirm-role-button',
  cancelRoleButton: 'admin-cancel-role-button',
  deleteUserButton: 'admin-delete-user-button',
  reportRow: 'admin-report-row',
  deleteReportButton: 'admin-delete-report-button',
  confirmDeleteModal: 'admin-confirm-delete-modal',
  confirmDeleteBtn: 'admin-confirm-delete-btn',
  cancelDeleteBtn: 'admin-cancel-delete-btn',
};
